import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

//
import { ProgressBar } from "react-bootstrap";

//
import NothingToShow from "../general/NothingToShow";

function Allocation({ data }) {
  const [allocation, setAllocation] = useState([]);

  const sortValues = () => {
    if (data) {
      let array = [];
      for (const [key, value] of Object.entries(data)) {
        array.push({ key, value });
      }

      let list = array.sort((a, b) => (+a.value.USDT > +b.value.USDT ? -1 : 1));

      setAllocation(list);
    } else {
      setAllocation([]);
    }
  };

  useEffect(() => {
    sortValues();

    // eslint-disable-next-line
  }, [data]);

  return (
    <div className="allocation">
      {allocation.length ? (
        <>
          <ProgressBar>
            {allocation.map((item, i) => (
              <ProgressBar className={item.key} now={item?.value?.USDT} key={i} />
            ))}
          </ProgressBar>

          <div className="coins">
            {allocation.map((item, i) => (
              <div
                className={`item ${item.key} ${
                  +item?.value?.USDT > 15 ? "d-flex" : "d-flex d-xl-none"
                }`}
                style={{ width: `${item?.value?.USDT}%` }}
                key={i}
              >
                <p className="fw-bolder text-black">{item.key}</p>
                <p className="fw-bolder">{item?.value?.USDT}%</p>
              </div>
            ))}
          </div>
        </>
      ) : (
        <NothingToShow text="No asset" />
      )}
    </div>
  );
}

Allocation.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Allocation;
